import { Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import PhoneIcon from '@mui/icons-material/Phone'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import { Controller, useForm } from 'react-hook-form'
import { FormService } from '@Services/form.service'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import ClientAmmunitionActions from '@ClientActions/ammunition.action'
import ClassificationAction from '@ClientActions/classification.action'
import { ICommonQuery, IUpdate } from '@Models/common.model'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import { MClassification } from '@Models/classification.model'
import { MAmmunition } from '@Models/client/ammunition.model'
import clsx from 'clsx'
import moment from 'moment'
import { EClassifications } from '@Enum/classifications.enum'

// dummy data
const defaultValues: any = {
    madeAt: null,
    make: '',
    qty: '',
    caliber: '',
    qmicrostamp: '',
    fflId: '',
    transactionDetail: {
        salesRep: '',
        businessName: '',
        phone: '',
        address: '',
    },
}

// models section
interface IDetailAmmunitionModal {
    open: boolean
    onClose: () => void
    data: MAmmunition

    // redux
    makes?: MClassification[]
    updateAmmunition?: (payload: IUpdate<any>) => Promise<any>
}

function DetailAmmunitionModal(props: IDetailAmmunitionModal) {
    // core section
    const { open, onClose, makes, data, updateAmmunition } = props
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm({ defaultValues })
    const classesInput = 'reddit-input w-100'
    const ac = new AbortController()

    // states section
    const [disabled, setDisabled] = useState(false)

    // hooks section
    /**
     * reset form data with new value passing
     */
    useEffect(() => {
        setDisabled(true)

        if (data) {
            reset(data)
        } else {
            setTimeout(() => {
                reset(data)
            }, 1000)
        }
        return () => {
            ac.abort()
        }
    }, [open])

    // functions section
    /**
     * handle submit and update ammunition
     * @param formData inputs value
     */
    const onSubmit = (formData: any) => {
        setDisabled(true)
        const {
            make,
            madeAt,
            caliber,
            qmicrostamp,
            fflId,
            qty,
            transactionDetail,
        } = formData
        const type = 'AMMUNITION'
        const payload = {
            make,
            madeAt: moment(madeAt).toISOString(),
            caliber,
            qmicrostamp,
            fflId,
            type,
            qty: +qty,
            transactionDetail,
        }
        const body: IUpdate<any> = { id: data?.id, payload }
        onClose()
        // if (updateAmmunition)
        //     updateAmmunition(body)
        //         .then(() => {
        //             onClose()
        //             setDisabled(false)
        //         })
        //         .catch(() => setDisabled(false))
    }

    // main section
    return (
        <CustomModal modalTitle={data?.name} open={open} onClose={onClose}>
            <div className="modal-body p-0 pb-2">
                <Grid container spacing={2}>
                    <Grid item xs={12} container spacing={2}>
                        <Grid item xs={6}>
                            <div className="page-name-desc-box page-white-card p-4">
                                <p className="name">
                                    {data?.transactionDetail?.businessName ||
                                        ' - '}
                                </p>
                                <p className="phone">
                                    <PhoneIcon
                                        className="phone-icon mr-1"
                                        style={{ fontSize: 12 }}
                                    />
                                    {data?.transactionDetail?.phone || ' - '}
                                </p>
                                <ul className="description">
                                    <li>
                                        {data?.transactionDetail?.address ||
                                            ' - '}
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                control={control}
                                name="madeAt"
                                defaultValue={null}
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <BaseDatePicker
                                        label="Date"
                                        onChange={onChange}
                                        className={clsx(classesInput, 'mb-2')}
                                        value={value}
                                        fullWidth
                                        inputRef={ref}
                                        error={errors?.madeAt && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'madeAt',
                                            'Date'
                                        )}
                                        readOnly
                                        // disabled={disabled}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="make"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <BaseSelect
                                        {...field}
                                        label="Make"
                                        className={classesInput}
                                        value={value}
                                        onChange={onChange}
                                        options={makes}
                                        fullWidth
                                        error={errors?.make && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            `make`,
                                            'Make'
                                        )}
                                        inputRef={ref}
                                        readOnly
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} className="pt-2">
                            <Controller
                                control={control}
                                name="transactionDetail.salesRep"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Sales Rep"
                                        variant="filled"
                                        className={classesInput}
                                        error={
                                            errors?.transactionDetail
                                                ?.salesRep && true
                                        }
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'transactionDetail.salesRep',
                                            'Sale Rep'
                                        )}
                                        inputProps={{ readOnly: true }}
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} className="pt-2">
                            <Controller
                                control={control}
                                name="qty"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        type="number"
                                        label="Qty"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.qty && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'qty',
                                            'Qty'
                                        )}
                                        inputProps={{ readOnly: true }}
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} />
                        <Grid item xs={6} className="pt-2">
                            <Controller
                                control={control}
                                name="caliber"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Caliber"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.caliber && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'caliber',
                                            'Caliber'
                                        )}
                                        inputProps={{ readOnly: true }}
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} />
                        <Grid item xs={6} className="pt-2">
                            <Controller
                                control={control}
                                name="qmicrostamp"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Micro Stamp #"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.qmicrostamp && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'qmicrostamp',
                                            'Micro Stamp #'
                                        )}
                                        inputProps={{ readOnly: true }}
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} />
                        <Grid item xs={6} className="pt-2">
                            <Controller
                                control={control}
                                name="fflId"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="FFL #"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.fflId && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'fflId',
                                            'FFL #'
                                        )}
                                        inputProps={{ readOnly: true }}
                                        // disabled={disabled}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div className="modal-footer">
                <span className="modal-action" onClick={handleSubmit(onSubmit)}>
                    OK
                </span>
            </div>
        </CustomModal>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { ammunition } = store?.client?.ammunition
    const { makes } = store?.client.classifications
    return {
        ammunition,
        makes,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getAmmunition, addAmmunition, updateAmmunition } =
        ClientAmmunitionActions
    const { getClassifications } = ClassificationAction
    return {
        getMakes: () =>
            dispatch(getClassifications(EClassifications.MAKE) as any),
        getAmmunition: (params?: ICommonQuery) =>
            dispatch(getAmmunition(params) as any),
        addAmmunition: (body: any) => dispatch(addAmmunition(body) as any),
        updateAmmunition: (payload: IUpdate<any>) =>
            dispatch(updateAmmunition(payload) as any),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailAmmunitionModal)
